import React from 'react';
import PropTypes from 'prop-types';

import Switch from 'react-switch';

export const ISwitch = ({
  title,
  checked,
  enable = true,
  onChangeBooleanHandler,
}: any) => {
  return (
    <Switch
      id={title}
      name={title}
      disabled={!enable}
      className="switch text-capitalize"
      checked={checked}
      onChange={(e) => onChangeBooleanHandler(e, title)}
    />
  );
};

ISwitch.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  enable: PropTypes.bool,
  onChangeBooleanHandler: PropTypes.func,
};
